import { Component, effect, inject } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { OrganizationSettingsBudgetChapterStore } from './organization-settings-budget-chapter.store';
import { BudgetChapterObject } from '@libs/types/src/mado/object-type/organization/budget-chapter.object';
import { budgetChapterFrag } from './organization-settings-budget-chapter.query';
import {
    OrganizationSettingsBudgetChapterDialogComponent,
} from './dialog/organization-settings-budget-chapter-dialog.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../modules/shared/components/kit/table/table.component';


@Component({
    selector: 'app-organization-settings-budget-chapter',
    templateUrl: './organization-settings-budget-chapter.component.html',
    providers: [OrganizationSettingsBudgetChapterStore],
    imports: [
        TranslatePipe,
        PrimeTemplate,
        TableComponent,
    ],
})
export class OrganizationSettingsBudgetChapterComponent {
    protected readonly store = inject(OrganizationSettingsBudgetChapterStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly prefix = 'organization-settings.mado.budgetChapter.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        {
            name: 'code',
        },
        {
            name: 'description',
        },
        {
            name: 'parentId',
        },
    ];

    constructor() {
        effect(() => {
            this.loadBudgetChapters();
        });
    }

    openDialog(budgetChapter: BudgetChapterObject | null = null) {
        const header = `${this.prefix}title` + (budgetChapter ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsBudgetChapterDialogComponent,
            {
                header: translate.instant(header),
                data: { budgetChapter },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadBudgetChapters();
            }
        });
    }

    async loadBudgetChapters() {
        const organizationId = routeParams.organizationId();

        await this.store.api.getBudgetChapters(FilterBuilder.singlePage({ organizationId }), budgetChapterFrag);
    }
}
